module.exports = __webpack_public_path__ + "img/tire-2.f0703aec.png";